// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__zwv_a","container":"SectionHeader_container__odVoY","header__heading":"SectionHeader_header__heading__gvhAq"};